/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button } from "@mui/material";

// Custom simple "Add Link" button component
const CustomAddLinkButton = (props) => {
    const setOpen = props?.setOpen;
    
    return (
        <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(true)}
            style={{ width: "120px", height: "40px" }}
        >
            Add Link
        </Button>
    );
};

export { CustomAddLinkButton };
